import isTokenRefused from './isTokenRefused';

interface ResolveMagicLinkSignInParams {
  magicLinkResponse: Response | null;
  jwtToken: string;
  cookieToken: string | null | undefined;
  exchangeToken: (token: string) => Promise<Response>;
}

// Returns the response to sign in with, or null when the member has to sign in again.
const resolveMagicLinkSignIn = async ({
  magicLinkResponse,
  jwtToken,
  cookieToken,
  exchangeToken,
}: ResolveMagicLinkSignInParams): Promise<Response | null> => {
  if (!isTokenRefused(magicLinkResponse)) return magicLinkResponse;
  if (!cookieToken || cookieToken === jwtToken) return null;

  const cookieResponse = await exchangeToken(cookieToken);
  return isTokenRefused(cookieResponse) ? null : cookieResponse;
};

export default resolveMagicLinkSignIn;
